<!-- 左侧菜单 -->
<template>
  <div class="navWrap">
    <div class="nav">
      <div class="navItem" v-for="(item, index) in navList" :class="{ active: index == active }" :key="index"
        @click="navChange(item, index)">
        <div class="pic"><img :src="item.imgUrl" alt=""></div>
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/common/bus.js'
import Cookies from "js-cookie";
import { outLink,init } from '@/common/outLink.js'
export default {
  name: 'Nav',
  data() {
    return {
      active: 2,
      navList: [
        {
          name: '个人仓库',
          imgUrl: require('@/assets/imgs/shop/nav0.png'),
          routerUrl: '/shop/personWarehouse',
        },
        {
          name: '幸运盲盒',
          imgUrl: require('@/assets/imgs/shop/nav1.png'),
          routerUrl: '/shop/blindBox',
        },
        {
          name: '热卖区',
          imgUrl: require('@/assets/imgs/shop/nav2.png'),
          routerUrl: '/shop?type=hot',
        },
        {
          name: '超值购',
          imgUrl: require('@/assets/imgs/shop/nav3.png'),
          routerUrl: '/shop?type=supper',
        },
        {
          name: '积分专区',
          imgUrl: require('@/assets/imgs/shop/nav4.png'),
          routerUrl: '/shop?type=integralArea',
        },
        {
          name: '神秘黑市',
          imgUrl: require('@/assets/imgs/shop/nav6.png'),
          routerUrl: '/shop?type=blackMarket',
        },
        {
          name: '消费排行榜',
          imgUrl: require('@/assets/imgs/shop/nav7.png'),
          isOutLink: true,
          routerUrl: outLink.officeRank,
        },
      ],
    }
  },
  components: {
  },
  created() {

  },
  mounted() { },
  methods: {
    navChange(item, index) {   // 点击菜单
      if (Cookies.get('cwsl_token')) {
        if (item.isOutLink) {
          window.open(item.routerUrl);
        } else if (item.name == '神秘黑市') {
          this.$message.info('系统升级，尽情期待！！！')
        } else {
          this.$router.push({ path: item.routerUrl })
          this.active = index
        }
      } else {
        this.$message.error('请先登录！')
      }
    },
    routeChange(to, from) {                  // 路由参数切换
      if (to.query.type == 'supper') {            // 超值购
        this.active = 3
      } else if (to.query.type == 'blackMarket') {  // 神秘黑市
        this.active = 5
      } else if (to.query.type == 'integralArea') {
        this.active = 4
      } else if (to.query.type == 'shoppingMall') {
        this.active = 1
      } else {                                 // 热卖
        this.active = 2
      }
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        this.routeChange(to, from)
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  }
}
</script>
<style scoped lang="less">
.navWrap {
  padding: 5px 0;
  background: #E3E8FF;

  .nav {
    .navItem {
      display: flex;
      padding: 0 10px 0 39px;
      height: 90px;
      align-items: center;
      cursor: pointer;

      .pic {
        margin-right: 14px;
      }

      span {
        font-size: 26px;
        color: #333;
      }
    }

    .active {
      background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
    }
  }
}
</style>
